import * as springroll from "springroll";
import * as CaptionData from "../../json/close-caption.json";
import {Subscriber} from "../core/Subscriber";
import {CaptionToken} from "../data/CaptionToken";
import * as Topics from "../data/Topics";

export interface ICaptionRenderer extends springroll.IRender {
    visible: boolean;
    onResize(pSize: PIXI.Point): void;
}

export class CaptionManager extends Subscriber {

    private static _instance: CaptionManager;

    static get instance() {
        return this._instance || (this._instance = new CaptionManager());
    }

    private _active: boolean;
    private readonly _data: any;
    private _player: springroll.CaptionPlayer | undefined;
    private _renderer: ICaptionRenderer | undefined;

    constructor() {
        super();
        this._active = true;
        this._data = (CaptionData as any).default;

        this.subscribe(Topics.PLAY_CAPTION, this.onPlayCaptionRequested.bind(this));
        this.subscribe(Topics.STOP_CAPTION, this.onStopCaptionRequested.bind(this));
    }

    public getCaption(vo: string) {
        const data = this._data[vo];
        if (data) {
            return data[0].content;
        }
        return "";
    }

    public getDuration(vo: string) {
        const data = this._data[vo];
        if (data) {
            return (data[0].end - data[0].start) / 1000;
        }
        return NaN;
    }

    public setRenderer(pRenderer: ICaptionRenderer): void {
        this._renderer = pRenderer;
        this._renderer.visible = this._active;
        if (this._player === undefined) {
            this._player = new springroll.CaptionPlayer(this._data, this._renderer);
        } else {
            this._player.renderer = this._renderer;
        }
    }

    public get active(): boolean {
        return this._active;
    }

    public set active(pValue: boolean) {
        this._active = pValue;
        if (this._renderer !== undefined) {
            this._renderer.visible = this._active;
        }
    }

    public update(pDelta: number): void {
        if (this._player !== undefined && this._active) {
            this._player.update(pDelta);
        }
    }

    public playCaption(pId: string, pStart: number = 0, pArgs?: any): void {
        if (this._player !== undefined) {
            this._player.start(pId, pStart, pArgs);
        }
    }

    public stopCaption(): void {
        if (this._player !== undefined) {
            this._player.stop();
        }
    }

    public onResize(pSize: PIXI.Point): void {
        if (this._renderer !== undefined) {
            this._renderer.onResize(pSize);
        }
    }

    private onPlayCaptionRequested(pTopic: string, pToken: CaptionToken): void {
        this.playCaption(pToken.id, pToken.start, pToken.args);
    }

    private onStopCaptionRequested(pTopic: string, pToken: CaptionToken): void {
        this.stopCaption();
    }
}
